module.exports = __webpack_public_path__ + "img/dengbao.10595694.jpg";